module.exports = __webpack_public_path__ + "img/Logo_Equipacare-Horizontal.2679ead2.png";